// extracted by mini-css-extract-plugin
export default {"circle":"ObjectCompare_circle__gE93J","dividerSty":"ObjectCompare_dividerSty__pqiJ7","compareSection":"ObjectCompare_compareSection__0inu3"};